<i class="fa fa-exclamation-circle icon-required"
    *ngIf="visible"
    aria-hidden="true"
    tooltip="{{ 'CLIENTERROR.CERR-00001' | translate }}"
    containerClass="tooltip-required"></i>